@let traductions = referentiel().metadonnees.traductions;

<form class="gap-lg grid" [formGroup]="form">
  <div hlmField>
    <label hlmFieldLabel for="input-nom" labelRequired
      >Nom de la {{ traductions.familleDeLivrables.toLowerCase() }}</label
    >
    <input id="input-nom" hlmInput type="text" formControlName="nom" />
    @if (nom.hasError('required')) {
      <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
    }
    @if (form.get('nom')?.hasError('notUnique')) {
      <hlm-field-error>Cette {{ traductions.familleDeLivrables.toLowerCase() }} existe déjà.</hlm-field-error>
    }
  </div>
</form>
